import React, { useState } from "preact/compat";
import { CompareList } from "../../Sportsbooks/CompareList/CompareList";
import { Footer } from "../../../📰Templates/Betslip/Footer/Footer";
import { calculateParlayOdds } from "../../../../helper/calculator";
import { Callout } from "../../../💠Molecules/Callout/Callout";
import { currencyFormatter } from "../../../../helper/currencyFormatter";
import { PartnerWager } from "../../../💠Molecules/Betslip/PartnerWager/PartnerWager";
import Checkbox from "../../../💎Atoms/Form/Checkbox/Checkbox";
import { GameInfo } from "../../../💠Molecules/Betslip/GameInfo/GameInfo";
import { eventDispatcher } from "../../../../helper/aa-event-dispatcher";
import { ParlayProps } from "./parlay.type";

export const Parlay: React.FunctionComponent<ParlayProps> = ({
  t,
  site,
  prWager,
  betData,
  selected,
  removeOldGames,
  updateParlayWager,
  updateSelectdParlay,
  removeGame
}) => {  
  // console.log('-------------- Switched to Parlay ------------------')
  // console.log(betData)

  const [selectedBets, setSelectedBets] = useState(selected)
  const [totalPOdds, setTotalPOdds] = useState<number>(0);

  const changePrWg = (event: any) => {
    event.target.value = event.target.value && !isNaN(event.target.value) ? currencyFormatter.format(event.target.value) : prWager;

    const qt: string = event.target.value;
    eventDispatcher("bet-slip", "parlay-tab-wager-change", qt, "Input Field", 'onBlur')
    updateParlayWager(qt);
  }

  const updateSelect = (event: any) => {
    const index: number = event.target.value.replace("checkbox-", "");

    eventDispatcher("bet-slip", "parlay-tab-select-leg", betData.getBets()[index].game.gameId, "Checkbox", 'onClick')
    setSelectedBets(updateSelectdParlay(index))
    setTotalPOdds(calculateParlayOdds(betData.getBets(), selectedBets));

    const value = selectedBets[index] !== -1 ? 'selected' : 'deselected';
    eventDispatcher("bet-slip", "parlay-tab-select-leg", betData.getBets()[index].game.gameId, "Checkbox", value)
  }

  const deleteGame = (event: any) => {
    const selectIndex: number = parseInt(event.target.id.replace('game-', ''));
    eventDispatcher("bet-slip", "parlay-tab-remove-bet", betData.getBets()[selectIndex].game.gameId, "Input Field", 'onClick')

    setSelectedBets(removeGame(selectIndex, null));
  }

  setTotalPOdds(calculateParlayOdds(betData.getBets(), selectedBets));
  
    return (
      betData.getTotalBets() > 1 ?
        <div>
          {selectedBets.filter((sl: number) => sl !== -1)?.length > 1 ?
            <span className="position-absolute end-0 me-4 fs-8" style={{marginTop: "-40px"}}>
              {selectedBets.filter((sl: number) => sl !== -1)?.length} 
              <span className="text-uppercase ms-1">{t.parlay_content.total} 
                {!(betData.isSameGame(selectedBets).length > 0) && betData.parlayComparisonVm.bestSelectedParlay?.odds ? 
                  <b className="ms-1"> {betData.parlayComparisonVm.bestSelectedParlay?.odds}</b>
                  : ''}
              </span> 
            </span>
            : ''}
          <div className='content-overflow px-3'>
            <Callout toggleVisibility={betData.getTotalBets() > 12} className="px-2 align-items-start icon" type="warning" dismissible={false}>
              {t.warning_messages.maximun_selection} 
            </Callout>
            <Callout toggleVisibility={betData.isSameGame(selectedBets) > 0} className="px-2 align-items-start icon" type="warning" dismissible={false}>
              {t.warning_messages.same_game_parlay}
            </Callout>
            <Callout toggleVisibility={selectedBets.filter((sl: number) => sl !== -1)?.length < 2} className="px-2 align-items-start icon" type="warning" dismissible={false}>
              {t.empty_parlay_message.heading} 
            </Callout>
            <Callout toggleVisibility={betData.getStartedGames() !== ''} className="px-2 align-items-start icon" type="warning" dismissible={false}>
              {betData.getStartedGames()}
            </Callout>
            <Callout toggleVisibility={betData.hasDifferentPartners(selectedBets)} className="px-2 align-items-start icon" type="warning" dismissible={true}>
              {t.warning_messages.different_partners} 
            </Callout>
            <div className="wager-parlay-card-container d-flex flex-column border rounded shadow-sm p-2 mb-3">
                {betData.getBets().slice(0, 12).map((bt: any, index: number) => {
                    return (
                        <div className={`wager-parlay-card-heading d-flex justify-content-between align-items-start mb-2i ${index > 0 ? "border-top pt-2" : ""}`}>
                            <div className="d-flex align-items-start">
                                <Checkbox id={`checkbox-${index}`} className="checkbox-1 me-1 mt-1 " valText={`checkbox-${index}`} checked={selectedBets[index] !== -1 ? true : false} disabled={false} onChange={updateSelect} /> 
                                {/* DISABLED      betData.getStartedGames(index) !== '' ? true : false */}
                                <GameInfo 
                                    site={site}
                                    gameInfo={bt.game[bt.selectedTeam]}
                                    gameData={bt}
                                    disabled={selectedBets[index] !== -1 ? false : true}
                                    showLeague={true}
                                    warning={betData.isSameGame(selectedBets).find((ids: string) => ids === bt.game.gameId)}  />
                                    {/* DISABLED   betData.getStartedGames(index) !== '' || selectedBets[index] === -1 ? true : false */}
                            </div>
                            <button className="btn btn-link p-0 ps-2i pb-2i">
                              <img id={`game-${index}`} src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25' fill='none'%3E%3Cpath d='M5 6.5H20M10 6.5V4.5C10 3.94772 10.4477 3.5 11 3.5H14C14.5523 3.5 15 3.94772 15 4.5V6.5M12.5 9V17M15.5 9L15 17M9.5 9L10 17M18.5 6.5L17.571 18.5767C17.5309 19.0977 17.0965 19.5 16.574 19.5H8.42603C7.90349 19.5 7.46905 19.0977 7.42898 18.5767L6.5 6.5H18.5Z' stroke='%23B6B7BB' stroke-width='1.2'/%3E%3C/svg%3E" alt="Trash can icon" onClick={deleteGame} />
                            </button>
                        </div>
                        )
                    })}

                {betData.parlayComparisonVm.bestSelectedParlay && betData.parlayComparisonVm.bestSelectedParlay?.sportsbookVm ?
                  <PartnerWager 
                    t={t} 
                    site={site}
                    link={betData.parlayComparisonVm?.bestSelectedParlay?.sportsbookVm?.sportsbookClickout}
                    wagerId={`wager-parlay-${`0`}`}
                    bet={betData.parlayComparisonVm?.bestSelectedParlay?.sportsbookVm}
                    disabled={!(betData.isSameGame(selectedBets).length > 0) && selectedBets.filter((sl: number) => sl !== -1)?.length > 1 ? false : true}     /* betData.getStartedGames(0) !== '' ? true : false */
                    wager={betData.parlayWager} 
                    win={!(betData.isSameGame(selectedBets).length > 0) && selectedBets.filter((sl: number) => sl !== -1)?.length > 1 ? betData.parlayComparisonVm.bestSelectedParlay?.toWin : 0} 
                    onBlurWager={changePrWg} />
                : ''}    
                
            </div>
            {betData.parlayComparisonVm.bestSelectedParlay ?
              <CompareList 
                t={t} 
                site={site}
                view="parlay"
                comparisonBets={betData.parlayComparisonVm.sortedComparisonList} 
                bet={!(betData.isSameGame(selectedBets).length > 0) && selectedBets.filter((sl: number) => sl !== -1)?.length > 1 ? prWager : -1} />
            : ''}
          </div>
          <Footer 
              t={t.footer}
              site={site}
              tab="parlay"
              betData={betData}
              selectedBets={selectedBets}
              onRemoveGames={removeOldGames} /> 
        </div>
      :
        <div id="empty-message" className="mt-4 px-3">
          <div><i class="mat-icon-slip2"></i> <span class='visually-hidden'>Trash can icon</span></div>
          <div className='mt-2 mb-1 w-75 lh-base fw-bold'>{t.empty_parlay_message.heading}</div>
          <p className='small lh-lg'>{t.empty_parlay_message.description}</p>
        </div>
    )
};
